import "./App.css";
import {
  UnderConstruction,
  Hero,
  About,
  Schedule,
  Tracks,
  FAQ,
  Sponsors,
  Footer
} from "./components";
import React from "react";

import "bootstrap/dist/js/bootstrap.min.js"; // Import Bootstrap JavaScript
import "bootstrap/dist/css/bootstrap.min.css";

import { HashRouter, Route, Routes } from "react-router-dom";

import { useRef } from "react";

function App() {
  const refToAbout = useRef(null);
  const refToSchedule = useRef(null);
  const refToTracks = useRef(null);
  const refToFAQ = useRef(null);
  const refToSponsors = useRef(null);

  return (
    <HashRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero
                refToAbout={refToAbout}
                refToSchedule={refToSchedule}
                refToTracks={refToTracks}
                refToFAQ={refToFAQ}
                refToSponsors={refToSponsors}
              />
              <About ref={refToAbout} />
              <Schedule ref={refToSchedule} />
              <Tracks ref={refToTracks}/>
              <FAQ ref={refToFAQ}/>
              <Sponsors ref={refToSponsors}/>
              <Footer/>
            </>
          }
        />
        <Route path="/soon" element={<UnderConstruction />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
